import React, { useState, Fragment, useEffect } from "react";
import { LoginPhoneForm } from "./Form";
import { useLayoutHeader } from "components/MainLayout";
import { Row, Col } from "antd";
import { getAuthApi } from "api";
import roroLogin from "./RoRo-login.png";
import Typography from "antd/es/typography";
import { fixNumbers } from "utils";

const headerConfig = {
	pageTitle: "ورود",
	closeable: true,
	menuEnabled: false,
	extra: [],
	backIcon: true,
};

const LoginPhoneFormContainer = ({ onCodeSent, timer, setTimer }) => {
	const { Title } = Typography;
	useLayoutHeader(headerConfig);
	const [{ submitting, failed }, setState] = useState({ submitting: false, failed: false });
	const onFinish = ({ phone }) => {
		setState({ submitting: true, failed: false });
		getAuthApi()
			.requestAuthCode({ phone: fixNumbers(phone) })
			.then((res) => {
				if (onCodeSent) {
					setTimer(100);
					onCodeSent({ codeKey: res.codeKey, phone });
				}
			})
			.catch(() => {
				setState({ submitting: false, failed: true });
			});
	};

	useEffect(() => {
		timer && setTimeout(() => setTimer((perValue) => (perValue ? perValue - 1 : 0)), 1000);
	}, [timer]);

	return (
		<Fragment>
			<Row>
				<img src={roroLogin} alt="roro-login" style={{ width: "100%", display: "none" }} />
				<Col span={24} className="px-40 f-30">
					<Title level={2} className="mb-36">
						ثبت‌ نام یا ورود
					</Title>
				</Col>
				<Col span={24} className="px-40">
					<LoginPhoneForm failed={failed} submitting={submitting} onFinish={onFinish} timer={timer} />
				</Col>
			</Row>
		</Fragment>
	);
};

export default LoginPhoneFormContainer;
